// extracted by mini-css-extract-plugin
module.exports = {"Copyright":"Copyright_Copyright__11qaZ","Policy":"Copyright_Policy__2s-0J","Title":"Copyright_Title__7pzuH","SectionTitle":"Copyright_SectionTitle__Atv5o"};